import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityHeaderWatchlist } from '~/components/entity-header-watchlist/EntityHeaderWatchlist';
import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useEntity } from '~/hooks/use-entities';
import { useSnakeMeta } from '~/hooks/use-snake/useSnake';
import { ChartPrice } from '~/modules/simple-chart/components/chart-price/ChartPrice';

import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '../useEarningsInsightDrawer';
import { DocumentModal } from './components/document-modal/DocumentModal';
import { EarningsPreview } from './earnings-preview/EarningsPreview';
import { EarningsRecap } from './earnings-recap/EarningsRecap';
import * as S from './EarningsInsightWidget.styles';

export const EarningsInsightWidget = () => {
  const { t } = useTranslation(['earnings']);
  const { switchTab, activeTabIndex, activeTab, activeEntityTag } =
    useEarningsInsightDrawer();
  const [resetKey, setResetKey] = useState(0);

  const { data: entityData } = useEntity(activeEntityTag ?? '');
  const entity = entityData?.data;
  const { data: snakeMeta } = useSnakeMeta(entity?.default_snake);

  return (
    <S.Root>
      <DocumentModal />
      {entity && (
        <S.Wrapper>
          <EntityHeaderWatchlist entity={entity} />
          <ChartPrice
            entity={entity}
            snakeMeta={snakeMeta}
            enablePriceHover={false}
          />
        </S.Wrapper>
      )}
      <S.StyledButtonGroup
        labels={[
          t('earnings:earningsInsight.drawer.earningsPreview.title'),
          t('earnings:earningsInsight.drawer.earningsRecap.title'),
        ]}
        onClick={idx => {
          switchTab(idx);
          setResetKey(resetKey + 1);
        }}
        activeIndex={activeTabIndex}
      />
      <ErrorBoundaryWrapper resetKeys={[resetKey]}>
        <>
          {activeTab === SubTabsType.Preview ? (
            <EarningsPreview />
          ) : (
            <EarningsRecap />
          )}
        </>
      </ErrorBoundaryWrapper>
    </S.Root>
  );
};
